<div class="container-fluid">
	<div class="row">
		<div class="col-md-12">
			<ng-content></ng-content>
		</div>
	</div>
</div>
